<script lang="ts">
  import ScreenshotSectionContent from './ScreenshotSection--content.svelte';
  import type { ScreenshotSectionProps } from './types';

  type $$Props = ScreenshotSectionProps;

  export let entryId: ScreenshotSectionProps['entryId'];
  export let animation: ScreenshotSectionProps['animation'] = undefined;
  export let video: ScreenshotSectionProps['video'] = undefined;
  export let slideshowData: ScreenshotSectionProps['slideshowData'] = undefined;
  export let background: ScreenshotSectionProps['background'] = undefined;
  export let hasImage: ScreenshotSectionProps['hasImage'];
  export let hasMedia: ScreenshotSectionProps['hasMedia'];
  export let contentWidth: ScreenshotSectionProps['contentWidth'];
  export let fullWidth: ScreenshotSectionProps['fullWidth'];
  export let isTypeShadow: ScreenshotSectionProps['isTypeShadow'];
  export let imageDeviceFrameType: ScreenshotSectionProps['imageDeviceFrameType'] = undefined;
  export let aproposImage: ScreenshotSectionProps['aproposImage'] = undefined;
  export let imageConfig: ScreenshotSectionProps['imageConfig'] = undefined;
  export let imageConfigs: ScreenshotSectionProps['imageConfigs'] = undefined;
  // export let videoUrl: ScreenshotSectionProps['videoUrl'];
  export let paddingTop: ScreenshotSectionProps['paddingTop'] = undefined;
  export let paddingBottom: ScreenshotSectionProps['paddingBottom'] = undefined;
  export let linkId: ScreenshotSectionProps['linkId'] = undefined;
  export let boxProperties: ScreenshotSectionProps['boxProperties'];
  export let customCssClass: ScreenshotSectionProps['customCssClass'];

  // TODO: Investigate if image_break_background_colors need to be migrated over
  // XMSFE-240 - https://jira.sqprod.co/browse/XMSFE-240
  let backgroundColorCssVar: string = '--color-white';
  if (background === 'gray') {
    backgroundColorCssVar = '--color-gray-05';
  } else if ($$props.background === 'black') {
    backgroundColorCssVar = '--color-gray-99';
  }

  const imageDeviceFrameColor: any = fullWidth || contentWidth ? undefined : $$props.imageDeviceFrameColor;
  const paddingTopCssVar = paddingTop ? `var(--space-${paddingTop})` : undefined;
  const paddingBottomCssVar = paddingBottom ? `var(--space-${paddingBottom})` : undefined;
  const widthClass = (contentWidth && 'contentWidth') || (fullWidth && 'fullWidth') || '';
  const boxPropertiesEnabled = boxProperties?.enabled ?? false;
</script>

<section
  class="ScreenshotSection ScreenshotSection-{entryId}-box-properties {customCssClass}"
  style:background-color={boxPropertiesEnabled ? '' : `var(${backgroundColorCssVar})`}
  style:padding-top={boxPropertiesEnabled ? '' : paddingTopCssVar}
  style:padding-bottom={boxPropertiesEnabled ? '' : paddingBottomCssVar}
  data-entry-id={entryId}
  data-frame-type={imageDeviceFrameType}
  id={linkId}
>
  <div class:content={!fullWidth}>
    <div style:position="relative" data-entry-id={aproposImage ? aproposImage.props.entryId : ''}>
      <div class={widthClass} style:box-shadow={isTypeShadow ? 'var(--frame-drop-shadow)' : 'none'}>
        <ScreenshotSectionContent
          {hasImage}
          {imageConfigs}
          {imageConfig}
          {aproposImage}
          {slideshowData}
          {hasMedia}
          {video}
          {animation}
          {imageDeviceFrameColor}
        />
      </div>
    </div>
  </div>
</section>

<style lang="scss">
  @use '@squareup/public-web-design-system/dist/styles/xms-fe/helpers/layout' as layout;

  @layer standard-components {
    .fullWidth {
      @include layout.media-clipped-at-extra-large();
    }
  }
</style>
